import React from 'react';
import { formatMessage } from '@99designs/frontend-components/i18n';
import BreadCrumbs from '../../../../shared/components/BreadCrumbs/BreadCrumbs';
import { categoryContestsPath, categoryPath } from '../../../../shared/lib/platformUrls';
import { ContestType } from '../ContestOverviewData';

interface Props {
    contest: ContestType;
}

function BreadCrumbsSection({ contest }: Props) {
    return (
        <BreadCrumbs
            breadcrumbs={[
                {
                    label: __('Home'),
                    path: '/',
                },
                {
                    label: contest.category.title,
                    path: categoryPath(contest.category.key),
                },
                {
                    label: formatMessage(__('{categoryTitle} contests'), {
                        categoryTitle: contest.category.title,
                    }),
                    path: categoryContestsPath(contest.category.key),
                },
                {
                    label: contest.title,
                },
            ]}
        />
    );
}

export default BreadCrumbsSection;
